export default __webpack_public_path__ + "static/media/WA.95b47015.svg";